import { Modal } from "react-bootstrap";
import { Wrapper } from "../styles";

export const PasswordTemplate = () => {
  return (
    <Wrapper className="modal-styles">
      <Modal.Header closeButton>
        <Modal.Title>Change Password Request</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="box-padding">
          An email has been sent to your address on file.
          <br />
          Please click the link and follow the instructions.
        </div>
      </Modal.Body>
    </Wrapper>
  );
};
